import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'panel'];

  connect() {
    this.hide();
  }

  toggle(event) {
    event.preventDefault();
    this.isOpen() ? this.hide() : this.show();
  }

  closeOnEscape(event) {
    if (!this.isOpen()) return;
    if (event.key === 'Escape') this.hide({ focusButton: true });
  }

  closeOnOutside(event) {
    if (!this.isOpen()) return;
    if (this.element.contains(event.target)) return;
    this.hide();
  }

  show() {
    this.panelTarget.hidden = false;
    this.buttonTarget.setAttribute('aria-expanded', 'true');
  }

  hide({ focusButton = false } = {}) {
    this.panelTarget.hidden = true;
    this.buttonTarget.setAttribute('aria-expanded', 'false');
    if (focusButton) this.buttonTarget.focus();
  }

  isOpen() {
    return this.panelTarget.hidden === false;
  }
}
